import { useBrandLoaderData, useRootLoaderMessageInfo } from "./rootLoader.ts";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useEffect } from "react";
import { initTheme } from "./core-ui/initTheme.ts";
import Tooltips from "./core-ui/tooltip/Tooltips.tsx";
import AppHead from "./helpers/AppHead.tsx";
import DeweyIntlProvider from "../../common/core-ui/DeweyIntlProvider.tsx";
import "./core-ui/z-index.scss";

export default function Root() {
  const brand = useBrandLoaderData();
  const rootMessageInfo = useRootLoaderMessageInfo();

  useEffect(() => {
    initTheme(brand.Theme);
  }, [brand]);

  const content = (
    <>
      <AppHead />
      <Outlet />
      <Tooltips />
      <ScrollRestoration />
    </>
  );

  if (rootMessageInfo) {
    return (
      <DeweyIntlProvider
        locale={rootMessageInfo.locale}
        messages={rootMessageInfo.messages}
      >
        {content}
      </DeweyIntlProvider>
    );
  }

  return content;
}
